module.exports = __webpack_public_path__ + "img/Ressources_IEA.8e64241d.png";